import MuiNavbar from "../components/MuiNavbar";

function LayoutAuth() {
  return <MuiNavbar />;
}

export default LayoutAuth;
